<template>
  <button
    @touchstart="getButtonClickedClass"
    @touchend="onPressClass = ''"
    :class="buttonClass"
    :style="{ background: onPressClass + '!important' }"
    :disabled="disabled"
    type="button"
  >
    <span v-if="loading" class="me-2">
      <div class="flex space-x-3 h-4 items-center">
        <div class="dot bg-GREY w-2.5 h-2.5 rounded-full animate-fade"></div>
        <div class="dot bg-GREY w-2.5 h-2.5 rounded-full animate-fade animation-delay-200"></div>
        <div class="dot bg-GREY w-2.5 h-2.5 rounded-full animate-fade animation-delay-400"></div>
      </div>
    </span>
    <template v-else>
      <div v-if="$slots.icon" class="pe-1.5">
        <slot name="icon"></slot>
      </div>
      <slot></slot>
    </template>
  </button>
</template>

<script setup>
import { ref, computed } from 'vue'

const onPressClass = ref()

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  square: {
    type: Boolean,
    default: false
  },
  circle: {
    type: Boolean,
    default: false
  },
  primary: {
    type: Boolean,
    default: false
  },
  secondary: {
    type: Boolean,
    default: false
  },
  quaternary: {
    type: Boolean,
    default: false
  },
  qua: {
    type: Boolean,
    default: false
  },
  green: {
    type: Boolean,
    default: false
  },
  text: {
    type: Boolean,
    default: false
  },
  tertiary: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: 'md'
  },
  active: {
    type: Boolean,
    default: false
  },
  progressColor: {
    type: String,
    default: '#3663f2'
  }
})

const getButtonClickedClass = () => {
  if (props.secondary) {
    onPressClass.value = '#4444E7'
  }
}

const buttonClass = computed(() => [
  'font-normal text-xs',
  'rounded-lg',
  'transition-all duration-300',
  'inline-flex items-center justify-center',
  'disabled:cursor-not-allowed',
  {
    
    'bg-PRIMARY text-WHITE hover:bg-SECONDARY disabled:bg-GREY': props.primary,
    '!bg-inherit border border-BORDER text-WHITE hover:bg-SECONDARY disabled:bg-GREY':
      props.primary && props.loading,
    'bg-SECONDARY text-WHITE disabled:bg-GREY': props.secondary,
    'bg-transparent border border-WHITE text-WHITE hover:bg-SECONDARY disabled:bg-GREY':
      props.secondary && props.loading,
    'bg-transparent border border-WHITE text-WHITE hover:bg-GREY disabled:bg-GREY disabled:border-WHITE disabled:border':
      props.tertiary,
      'bg-transparent border border-WHITE text-WHITE hover:bg-SECONDARY disabled:bg-GREY':
      props.tertiary && props.loading,

      'bg-PURPLEBLUE text-BLACK hover:bg-GREY disabled:bg-GREY disabled:border-WHITE disabled:border':
      props.quaternary,
      'bg-transparent border border-WHITE text-WHITE hover:bg-SECONDARY disabled:bg-GREY':
      props.quaternary && props.loading,

      'bg-LIGHTGREEN  text-WHITE hover:bg-GREEN disabled:bg-GREY disabled:border-WHITE disabled:border':
      props.green,
      'bg-transparent border border-WHITE text-WHITE hover:bg-SECONDARY disabled:bg-GREY':
      props.green && props.loading,
    'text-BLUE hover:underline disabled:text-GREY-3 !p-0': props.text,

    'py-3 px-5': props.size == 'lg',
    'py-3 px-3': props.size == 'md',
    'py-3 px-2': props.size == 'sm',
    'py-2 px-2': props.size == 'xs',

    'w-10 h-10 !p-0': props.square && props.size == 'lg',
    'w-9 h-9 !p-0': props.square && props.size == 'md',
    'w-8 h-8 !p-0': props.square && props.size == 'sm',
    'w-6 h-6 !p-0': props.square && props.size == 'xs',

    'w-10 h-10 !p-0 !rounded-full hover:bg-GREY': props.circle && props.size == 'lg',
    'w-9 h-9 !p-0 !rounded-full hover:bg-GREY': props.circle && props.size == 'md',
    'w-8 h-8 !p-0 !rounded-full hover:bg-GREY': props.circle && props.size == 'sm',
    'w-6 h-6 !p-0 !rounded-full hover:bg-GREY': props.circle && props.size == 'xs',
    'w-4 h-4 !p-0 !rounded-full hover:bg-GREY': props.circle && props.size == '2xs',

    'bg-SECONDARY hover:bg-SECONDARY': props.loading && props.primary,
    'bg-GREY hover:bg-GREY': props.loading && (props.secondary || props.tertiary)
  }
])
</script>

<style>
@keyframes fade {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
.animate-fade {
  animation: fade 1.5s infinite;
}

.animation-delay-200 {
  animation-delay: 0.2s;
}

.animation-delay-400 {
  animation-delay: 0.4s;
}
</style>
